import _regenerator from "D:/qianduan/residents-move/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/qianduan/residents-move/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "vant/es/toast/style/less";
import _Toast from "vant/es/toast";
import "vant/es/loading/style/less";
import _Loading from "vant/es/loading";
import "vant/es/list/style/less";
import _List from "vant/es/list";
import "vant/es/dialog/style/less";
import _Dialog from "vant/es/dialog";
import "vant/es/button/style/less";
import _Button from "vant/es/button";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import Vue from "vue";
Vue.use(_Button);
Vue.use(_Dialog);
Vue.use(_List);
Vue.use(_Loading);
Vue.use(_Toast);
var API_BASE = "/aiServer";
var PAGE_SIZE = 20;
export default {
  name: "DouyinReviewFailed",
  data: function data() {
    return {
      queryMode: "",
      platformType: "2",
      taskId: "",
      userId: "",
      role: "",
      month: "",
      works: [],
      total: 0,
      nextPage: 1,
      initialLoading: true,
      listLoading: false,
      finished: false,
      pageError: "",
      paginationError: ""
    };
  },
  computed: {
    platformName: function platformName() {
      return {
        "1": "小红书",
        "2": "抖音视频",
        "3": "视频号"
      }[this.platformType];
    }
  },
  mounted: function mounted() {
    var params = new URLSearchParams(window.location.search || "");
    var platformType = params.get("platformType") || "2";
    if (!["1", "2", "3"].includes(platformType)) {
      this.showInvalidLink();
      return;
    }
    this.platformType = platformType;
    var taskId = params.get("taskId");
    if (taskId !== null) {
      if (this.platformType !== "2" || !this.isPositiveIntegerParam(taskId)) {
        this.showInvalidLink();
        return;
      }
      this.queryMode = "task";
      this.taskId = taskId;
      this.loadFirstPage();
      return;
    }
    var userId = params.get("userId");
    var role = params.get("role");
    var month = params.get("month");
    if (!this.isPositiveIntegerParam(userId) || !["1", "2"].includes(role) || !/^\d{4}-(0[1-9]|1[0-2])$/.test(month || "")) {
      this.showInvalidLink();
      return;
    }
    this.queryMode = "month";
    this.userId = userId;
    this.role = role;
    this.month = month;
    this.loadFirstPage();
  },
  methods: {
    showInvalidLink: function showInvalidLink() {
      this.pageError = "详情链接无效";
      this.initialLoading = false;
    },
    isPositiveIntegerParam: function isPositiveIntegerParam(value) {
      if (!/^\d+$/.test(value || "")) return false;
      var number = Number(value);
      return Number.isInteger(number) && number > 0 && number <= 2147483647;
    },
    unwrap: function unwrap(response) {
      var body = response && response.data !== undefined ? response.data : response;
      if (!body) throw new Error("接口未返回数据");
      if (body.code !== undefined && body.code !== 0 && body.code !== 200) {
        throw new Error(body.msg || body.message || "读取审核结果失败");
      }
      if (body.status !== undefined && body.status !== 200) {
        throw new Error(body.msg || body.message || "读取审核结果失败");
      }
      return body.data !== undefined ? body.data : body;
    },
    requestPage: function requestPage(pageNo) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, response;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                pageNo: pageNo,
                pageSize: PAGE_SIZE
              };
              if (_this.queryMode === "task") {
                params.taskId = _this.taskId;
              } else {
                params.userId = _this.userId;
                params.role = _this.role;
                params.month = _this.month;
                if (_this.platformType !== "2") params.platformType = _this.platformType;
              }
              _context.n = 1;
              return axios.get("".concat(API_BASE, "/douyin-work-review/rejected-works"), {
                params: params,
                timeout: 30000
              });
            case 1:
              response = _context.v;
              return _context.a(2, _this.unwrap(response) || {});
          }
        }, _callee);
      }))();
    },
    requestRejectedCount: function requestRejectedCount() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, result, rejectedCount;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return axios.get("".concat(API_BASE, "/douyin-work-review/review-result-count"), {
                params: {
                  userId: _this2.userId,
                  role: _this2.role,
                  month: _this2.month
                },
                timeout: 30000
              });
            case 1:
              response = _context2.v;
              result = _this2.unwrap(response) || {};
              rejectedCount = Number(result.rejectedCount);
              return _context2.a(2, Number.isFinite(rejectedCount) && rejectedCount > 0 ? rejectedCount : 0);
          }
        }, _callee2);
      }))();
    },
    loadFirstPage: function loadFirstPage() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var page, records, pageTotal, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _this3.initialLoading = true;
              _this3.pageError = "";
              _this3.paginationError = "";
              _this3.finished = false;
              _context3.p = 1;
              if (!(_this3.queryMode === "month" && _this3.platformType === "2")) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return _this3.requestRejectedCount();
            case 2:
              _this3.total = _context3.v;
              if (!(_this3.total === 0)) {
                _context3.n = 3;
                break;
              }
              _this3.works = [];
              _this3.nextPage = 2;
              _this3.finished = true;
              return _context3.a(2);
            case 3:
              _context3.n = 4;
              return _this3.requestPage(1);
            case 4:
              page = _context3.v;
              records = Array.isArray(page.records) ? page.records : [];
              _this3.works = records;
              pageTotal = Number(page.total);
              _this3.total = Number.isFinite(pageTotal) && pageTotal >= 0 ? pageTotal : _this3.total;
              _this3.nextPage = 2;
              _this3.finished = records.length >= _this3.total || records.length === 0;
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              _this3.works = [];
              _this3.total = 0;
              _this3.pageError = _this3.errorMessage(_t);
            case 6:
              _context3.p = 6;
              _this3.initialLoading = false;
              _this3.listLoading = false;
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 5, 6, 7]]);
      }))();
    },
    loadMore: function loadMore() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var pageNo, page, records, pageTotal, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(_this4.finished || _this4.paginationError)) {
                _context4.n = 1;
                break;
              }
              _this4.listLoading = false;
              return _context4.a(2);
            case 1:
              pageNo = _this4.nextPage;
              _context4.p = 2;
              _context4.n = 3;
              return _this4.requestPage(pageNo);
            case 3:
              page = _context4.v;
              records = Array.isArray(page.records) ? page.records : [];
              _this4.works = _this4.works.concat(records);
              pageTotal = Number(page.total);
              if (Number.isFinite(pageTotal) && pageTotal >= 0) {
                _this4.total = pageTotal;
              }
              _this4.nextPage = pageNo + 1;
              _this4.finished = records.length === 0 || _this4.works.length >= _this4.total;
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
              _this4.paginationError = _this4.errorMessage(_t2);
              _this4.finished = true;
            case 5:
              _context4.p = 5;
              _this4.listLoading = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[2, 4, 5, 6]]);
      }))();
    },
    retryPage: function retryPage() {
      this.paginationError = "";
      this.finished = false;
      this.listLoading = true;
      this.loadMore();
    },
    formatPublishTime: function formatPublishTime(value) {
      if (!value) return "-";
      return String(value).replace("T", " ").substring(0, 19);
    },
    showReason: function showReason(work) {
      _Dialog.alert({
        title: "不合格原因",
        message: work.rejectionReason || "暂无具体不合格原因",
        messageAlign: "left",
        confirmButtonText: "知道了"
      });
    },
    isValidWorkUrl: function isValidWorkUrl(value) {
      if (!value) return false;
      try {
        var url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch (error) {
        return false;
      }
    },
    openWork: function openWork(value) {
      if (!this.isValidWorkUrl(value)) {
        _Toast("作品链接不可用");
        return;
      }
      window.location.href = value;
    },
    errorMessage: function errorMessage(error) {
      var responseBody = error && error.response && error.response.data;
      return responseBody && (responseBody.msg || responseBody.message) || error && error.message || "读取审核结果失败，请稍后重试";
    }
  }
};